<template>
  <div class="search" ref="search" id="search" :style="{'transform': transform, 'top': top, 'left':left}">
    <div v-if="show !== 3 && show !== 4" class="head_top">
     <Heads :customerName="info.customerName"/>
    </div>
    <div v-if="!show">
      <div class="search-head">
        <div>
          <router-link tag="span" :to="{name: 'bigDataHome'}" class="setCursor">跨境大数据平台</router-link> > 搜索
        </div>
        <div class='close' @click='close'>
          <img src='@/assets/images/home/back.png'/>
          返回
        </div>
      </div>
      <div class="search-list">
        <div class="filter">
          <div class="filter-top">
            <div class="input el-input-dark">
              <div class="text">入园企业</div>
              <el-input placeholder="请输入" v-model='filter.customerName'/>
            </div>
            <div class="line"></div>
            <div class="input el-input-dark" style="margin-right:20px;">
              <div class="text">商品名称</div>
              <el-input placeholder="请输入" v-model='filter.productCollect'/>
            </div>
            <el-button type="primary" @click="searchKeyword">搜索</el-button>
          </div>
          <div class="filter-list">
            <el-select
                class="el-input-dark mr-16px"
                v-model="filter.platformCollect"
                placeholder="选择平台"
                @change="searchKeyword"
                clearable
                filterable>
                <el-option v-for="(item, index) in sysSourceList" :key="index" :value="item" :label="item" />
            </el-select>
            <el-select
                class="el-input-dark mr-16px"
                v-model="filter.countryCollect"
                placeholder="选择站点"
                @change="searchKeyword"
                clearable
                filterable>
                <el-option v-for="(item, index) in countryList" :key="index" :value="item.country_code" :label="item. country_name" />
            </el-select>
            <!-- <el-select
                class="el-input-dark mr-16px"
                v-model="filter.leimu"
                placeholder="商品类目"
                @change="searchKeyword"
                clearable
                filterable>
                <el-option v-for="(item, index) in productTypeList" :key="index" :value="item.productName" :label="item.productName" />
            </el-select> -->
            <!-- <div class="time">
              <el-date-picker
                v-model="filter.searchDate"
                type="year"
                format="yyyy"
                value-format="yyyy"
                :clearable="false"
                @change="searchDateChange"
                placeholder="选择日期">
              </el-date-picker>
              <el-date-picker
            v-model="filter.searchDate"
      type="datetimerange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="searchDateChange"
      >
    </el-date-picker>
            </div> -->
            <div class="time">
          <el-date-picker
            v-model="filter.searchDate"
            type="daterange"
            range-separator="至"
            :readonly="false"
            @change="searchDateChange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            >
          </el-date-picker>
        </div>
          </div>
          <div v-if="isSearch && filter.customerName" class="tips">共找到"{{page.total}}"条包含<span class="red">{{filter.customerName}}</span>的企业</div>
          <div class='ux-tabs tabs'>
            <div class="ux-filter-records filter-records">
              <div class='content-list'>
                <el-table
                  empty-text="暂无数据"
                  class="table ux-dark-el-table"
                  :data="tableData"
                  element-loading-spinner="el-icon-loading">
                    <el-table-column width="60"  type="index" label='序号' align="center">
                    </el-table-column>
                    <el-table-column width="250" show-overflow-tooltip props="customerName" label='企业名称' align="center">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.customerName }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column  props="productCollect" width="220" label='商品名称' align="center">
                      <template slot-scope="scope">
                        <el-tooltip placement="top">
                        <div slot="content">
                          {{ scope.row.productCollect }}
                        </div>
                       <div >
                          {{ setProductCollect(scope.row.productCollect) }}
                        </div>
                     </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip v-for="(props, i) in tableHeader" :label='props.label' align="center" :key="i" :min-width="setWidth(props.prop)">
                      <template slot-scope="scope">
                        <div v-if="props.prop === 'customerName'" class="text">{{ checkCompanyName(scope.row.customerName) | isEmptyVal }}</div>
                        <div v-else class="text">
                          <div v-if="props.prop === 'transaction' " class="text">
                         {{setTransaction( scope.row[props.prop]) | isEmptyVal }}
                        </div>
                        <div v-else class="text">{{ scope.row[props.prop] | isEmptyVal }}</div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column width="160" show-overflow-tooltip props="enterTime" label='入园时间' align="center">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row.enterTime }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label='操作' align="center">
                      <template slot-scope="scope">
                        <div class="blue" @click="handleTableSelect(scope.row)">查看详情</div>
                      </template>
                    </el-table-column>
                </el-table>
              </div>
              <div class='pages'>
                <span>共 {{ page.total }} 条数据</span>
                <el-pagination
                  class="ux-dark-el-pagination"
                  small
                  background
                  layout="prev, pager, next"
                  :current-page="page.current"
                  :page-size="page.size"
                  :total="page.total"
                  @size-change="changesize"
                  @current-change="change"
                />
                <pagination @currentChange="change" @sizeChange="changesize"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show == 1">
      <div class="search-head">
        <div>
          <span class="setCursor" @click='hidden'>总览</span> > 企业数据
        </div>
        <!-- <div class="buttons">
          <div class="time" v-if="checked != 'jbxx'">
            <el-date-picker
              v-model="filter.searchDate"
              type="year"
              format="yyyy"
              value-format="yyyy"
              :clearable="false"
              @change="timeChange"
              placeholder="选择日期">
            </el-date-picker>
          </div>
          <el-button type="primary" @click="getsendReport">
            生成报告
          </el-button>
        </div> -->
        <div class='close' @click='hidden'>
          <img src='@/assets/images/home/back.png'/>
          返回
        </div>
      </div>
      <div class="content">
        <div class="pannels">
          <div v-if="item.isShow" class="pannel" @click="choose(item)" :class="{'active': checked == item.compontents}" v-for="(item, index) of list" :key="index">{{item.name}}</div>
          <el-popover
            v-if="menuItem.hasList"
            class="com_lItem marB20 rate_box"
            placement="right"
            trigger="hover">
              <div class="rate_list_box">
                <h2 class="title">汇率换算表<em v-if="rateData.date">（{{rateData.date}}）</em></h2>
                <div class="dec">平台在北京时间每日凌晨请求接口，有可能因各平台时差不同而导致筛选周期数据未精准匹配</div>
                <div class="base">默认币种：{{rateData.base}}</div>
                <el-table
                 border
                 :data="rateData.list"
                 height="calc(100vh - 150px)"
                 tooltip-effect="dark"
                 style="width: 100%">
                    <el-table-column show-overflow-tooltip width="100" label="源币种">
                      <template slot-scope="scope">
                        <span>{{ scope.row.currencyCode | isEmptyVal }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column show-overflow-tooltip width="200" label="汇率">
                      <template slot-scope="scope">
                        <span>{{ scope.row.multiplyRate | isEmptyVal }}</span>
                      </template>
                    </el-table-column>
                  </el-table>
              </div>
              <div slot="reference"><em>汇率换算表</em><i class="el-icon-warning-outline icon"></i></div>
          </el-popover>
        </div>
        <div style="overflow-y:visible;" class="bg">
          <component @detail="detail" :info="info" :is="checked"></component>
          <div v-if="!menuItem.hasList" class="com_empty_box">暂无权限</div>
        </div>
      </div>
    </div>
    <div v-if="show == 2">
      <div class="search-head">
        <div>
          首页 > {{detailType == 'bg' ? '报关' : '订单'}} > {{detailType == 'bg' ? '报关单明细' : '订单明细'}}
        </div>
        <div class='close' @click='hidden'>
          <img src='@/assets/images/home/back.png'/>
          返回
        </div>
      </div>
      <div class="detail-main">
        <div class="detail-head">
          <div class="detail-head-item" v-for="(item, index) in detailList" :key="index">
            {{item.name}}：{{item.value}}
            <!-- <div class="left">{{item.name}}：</div>
            <div class="right">{{item.value}}</div> -->
          </div>
        </div>
        <div class="detail-search" v-if="detailType == 'bg'">
          <div class="detail-search-item">
            <div class="search-item-text">电商平台</div>
            <el-select
              class="el-input-dark mr-16px"
              v-model="detailfilter.platformCollect"
              placeholder="选择平台"
              clearable
              @change="getDetailList"
              filterable>
              <el-option v-for="(item, index) in sysSourceList" :key="index" :value="item.sysSourceCode" :label="item.sysSourceName" />
            </el-select>
          </div>
          <div class="detail-search-item input el-input-dark">
            <div class="search-item-text text">物流运单号</div>
            <el-input placeholder="请输入" v-model='detailInfo.customsNo'/>
          </div>
          <div class="detail-search-item input el-input-dark">
            <div class="search-item-text text">订单编号</div>
            <el-input placeholder="请输入" v-model='detailfilter.orderId'/>
          </div>
        </div>
        <div class="detail-table">
          <div class='ux-tabs tabs'>
            <div class="ux-filter-records filter-records">
              <div class='content-list' style="height:auto">
                <el-table
                  empty-text="暂无数据"
                  class="table ux-dark-el-table"
                  :data="detailtableData"
                  show-overflow-tooltip
                  element-loading-spinner="el-icon-loading">
                    <el-table-column width="80" type="index" label='序号' align="center">
                    </el-table-column>
                    <el-table-column :show-overflow-tooltip="true" v-for="(props, i) in detailtableHeader" :label='props.label' align="center" :key="i">
                      <template slot-scope="scope">
                        <div class="text">{{ scope.row[props.prop] | isEmptyVal }}</div>
                      </template>
                    </el-table-column>
                    <!-- <el-table-column label='操作' align="center">
                      <template slot-scope="scope">
                        <div class="blue">查看详情</div>
                      </template>
                    </el-table-column> -->
                </el-table>
              </div>
              <div class='pages'>
                <span>共 {{ detailpage.total }} 条数据</span>
                <el-pagination
                  class="ux-dark-el-pagination"
                  small
                  background
                  layout="prev, pager, next"
                  :current-page="detailpage.current"
                  :page-size="detailpage.size"
                  :total="detailpage.total"
                  @size-change="sizeChange"
                  @current-change="currentChange"
                />
                <pagination @currentChange="currentChange" @sizeChange="sizeChange"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show == 3">
      <div><detail /></div>
    </div>
    <div v-if="show == 4">
      <div><wlDetail /></div>
    </div>
    <el-dialog
      title="选择数据报告模板"
      append-to-body
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      custom-class='commonDialog1'
      :visible.sync="reportSendshow"
    >
      <div class='mask'></div>
      <div class='ux-panel'>
        <div class='title'>选择数据报告模板</div>
        <div class='ux-tabs tabs'>
          <div class="ux-filter-records filter-records">
            <div class='content-list'>
              <el-table
                class="table ux-dark-el-table"
                :data="reporttableData"
                empty-text="暂无数据"
                @row-click="getCurrentRow"
                max-height="550"
                element-loading-spinner="el-icon-loading">
                  <el-table-column label="选择" align="center" width="65">
                    <template slot-scope="scope">
                      <el-radio v-model="radio"
                      :label="scope.$index">&nbsp;</el-radio>
                    </template>
                  </el-table-column>
                  <el-table-column v-for="(props, i) in reporttableHeader" :label='props.label' align="center" :key="i">
                    <template slot-scope="scope">
                      <div v-if="props.type">
                        {{((page.current - 1) * page.size) + scope.$index + 1}}
                      </div>
                      <div v-else>
                        <div class="text">{{ scope.row[props.prop] | isEmptyVal }}</div>
                      </div>
                    </template>
                  </el-table-column>
              </el-table>
            </div>
            <div class='pages'>
              <span>共 {{ reportpage.total }} 条数据</span>
              <el-pagination
                class="ux-dark-el-pagination"
                small
                background
                layout="prev, pager, next"
                :current-page="reportpage.current"
                @size-change="reportsizeChange"
                :page-size="reportpage.size"
                :total="reportpage.total"
                @current-change="reportcurrentChange"
              />
              <pagination @currentChange="reportcurrentChange" @sizeChange="reportsizeChange"/>
            </div>
            <div class="report-buttons">
              <el-button @click="sendReport" type="primary">确定</el-button>
              <el-button @click='reportSendshow = false'>取消</el-button>
            </div>
          </div>
        </div>
        <div class='close' @click='reportSendshow = false'>
          <img src='@/assets/images/home/close.png'/>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Heads from './compontents/heads.vue'
import common from '@/utils/common'
import apiPath from '@config/api.json'
// import languageObj from './lan.json'
import jbxx from './compontents/jbxx.vue'
import jygl from './compontents/jygl.vue'
import bg from './compontents/bg.vue'
import cc from './compontents/cc.vue'
import order from './compontents/order.vue'
import jr from './compontents/jr.vue'
import js from './compontents/js.vue'
import ps from './compontents/ps.vue'
import wl from './compontents/wl.vue'
import pagination from '@/components/main/bigData/home/compontents/pagination.vue'
import detail from './compontents/detail.vue'
import wlDetail from './compontents/components/wlDetail.vue'
import { Loading } from 'element-ui'
const projectData = require('@/utils/projectData.json')
const hostPath = require('@config/host')

const scopeExecutionJson = {
  '0': '通用模版',
  '1': '企业',
  '2': '机构',
  '3': '银行'
}
const {mapState, mapMutations} = require('vuex')

export default {
  components: {
    jbxx,
    jygl,
    bg,
    cc,
    order,
    wl,
    jr,
    js,
    ps,
    pagination,
    detail,
    wlDetail,
    Heads
  },

  data () {
    return {
      pickerOptions: {
        disabledDate (time) {
          return time.getMonth() !== 0
        }
      },
      menuItem: {
        jbxx: false, // 基本信息
        jygl: false, // 经营概览
        jr: false, // 金融
        order: false, // 订单
        wl: true, // 物流
        // ps: false, // 配送
        bg: false, // 报关
        cc: false, // 仓储
        js: false, // 结算
        hasList: false, // 处理是否有以上列表
        myReport: false // 我的报告
      },
      logoImg: '',
      checked: '',
      isSearch: false,
      reportSendshow: false,
      radio: '',
      sigleShow: false,
      form: {},
      transform: 'scale(1,1)',
      top: 0,
      left: 0,
      reportModelList: [],
      list: [],
      detailInfo: {},
      show: 0,
      filter: {
        customerName: '',
        productCollect: '',
        searchDate: [],
        platformCollect: '全部平台',
        countryCollect: '全部站点',
        leimu: '全部商品类目'
      },
      rules: [],
      tipsShow: false,
      detailfilter: {
        platformCollect: '',
        orderId: ''
      },
      tableData: [],
      tableHeader: [
        // {
        //   prop: 'customerName',
        //   label: '企业名称'
        // },
        // {
        //   prop: 'productCollect',
        //   label: '商品'
        // },
        {
          prop: 'storesNum',
          label: '店铺数量（家）'
        },
        {
          prop: 'transaction',
          label: '销售额（万）'
        },
        {
          prop: 'salesNum',
          label: '销量（件）'
        },
        {
          prop: 'shipNum',
          label: '物流（单）'
        },
        {
          prop: 'availableQty',
          label: '库存（件）'
        },
        {
          prop: 'totalPrice',
          label: '库存货值（万）'
        },
        {
          prop: 'declaredNum',
          label: '报关数量（单）'
        }
        // {
        //   prop: 'enterTime',
        //   label: '入园时间'
        // }
      ],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      reporttableData: [],
      reporttableDatas: [],
      reporttableHeader: [
        {
          prop: 'reportName',
          label: '报告名称'
        },
        {
          prop: 'scopeExecutionName',
          label: '执行范围'
        }
      ],
      reportpage: {
        current: 1,
        size: 10,
        total: 0
      },
      detailtableData: [],
      detailtableHeader: [
        {
          type: 'index',
          label: '序号'
        },
        {
          prop: 'productCollect',
          label: '商品名称'
        },
        {
          prop: 'shopQuantity',
          label: 'sku'
        },
        {
          prop: 'tradeTotal',
          label: '数量（件）'
        },
        {
          prop: 'sellingQuantity',
          label: '单价（元）'
        }
      ],
      detailtableHeader1: [
        {
          prop: 'productName',
          label: '商品名称'
        },
        {
          prop: 'sku',
          label: 'sku'
        },
        {
          prop: 'salesNum',
          label: '数量（件）'
        },
        {
          prop: 'productPrice',
          label: '单价（元）'
        }
      ],
      detailtableHeader2: [
        {
          prop: 'customsNo',
          label: '报关单号'
        },
        {
          prop: 'customsType',
          label: '报关方式'
        },
        {
          prop: 'customsCode',
          label: '申报地海关代码'
        },
        {
          prop: 'country',
          label: '目的国'
        },
        {
          prop: 'customerName',
          label: '物流商'
        },
        {
          prop: 'shipper',
          label: '发货人'
        },
        {
          prop: 'receiver',
          label: '收货人'
        },
        {
          prop: 'customsProductPiece',
          label: '数量（件）'
        },
        {
          prop: 'customsWeight',
          label: '重量（KG）'
        },
        {
          prop: 'price',
          label: '申报价值（元）'
        },
        {
          prop: 'customsStatus',
          label: '状态'
        },
        {
          prop: 'customsTime',
          label: '报关时间'
        }
      ],
      detailpage: {
        current: 1,
        size: 10,
        total: 0
      },
      detailList: [
        {
          name: '订单编号',
          value: ''
        }, {
          name: '所属平台',
          value: ''
        }, {
          name: '店铺',
          value: ''
        }, {
          name: '商品数量',
          value: ''
        }, {
          name: '承运人',
          value: ''
        }, {
          name: '运单编号',
          value: ''
        }, {
          name: '订单状态',
          value: ''
        }, {
          name: '订单日期',
          value: ''
        }
      ],
      info: {},
      modelShow: false,
      rateData: {}, // 汇率换算表
      checkCompanyNameList: ['思睿智观（深圳）科技有限公司', '深圳谷旦科技贸易有限公司', '深圳一果果贸易有限公司', '深圳铭睿实业有限公司', '深圳前海全路电子商务有限公司']
    }
  },

  computed: {
    ...mapState({
      model: (state) => {
        return state.home.model
      },
      warehouseList: (state) => {
        return state.home.warehouseList
      },
      countryList: (state) => {
        return state.home.countryList
      },
      productTypeList: (state) => {
        return state.home.productTypeList
      },
      shopList: (state) => {
        return state.home.shopList
      },
      sysSourceList: (state) => {
        return state.home.sysSourceList
      },
      isShowDetail: (state) => {
        return state.home.isShowDetail
      }
      // searchDate: (state) => {
      //   return state.home.searchDate
      // }
    })
  },
  watch: {
    isShowDetail: {
      handler (v) {
        // v===1.其他信息。3 报关详情 4物流详情
        v === 3 ? this.show = 3 : this.show = 1
        switch (v) {
          case 1:
            this.show = 1
            break
          case 3:
            this.show = 3
            break
          case 4:
            this.show = 4
            break
        }
      },
      immediate: true
    }
  },
  // watch: {
  //   searchDate: function (n) {
  //     this.searchKeyword()
  //   }
  // },
  beforeDestroy () {
    this.$store.dispatch('getisShowDetail', 1)
    this.$store.dispatch('getShowDetail', {})
  },
  created () {
    this.logoImg = projectData[hostPath.sysType].logo
    const getListMenu = common.getListMenu()
    if (getListMenu) {
      const setListMenu = window.JSON.parse(getListMenu)
      this.menuItem.jbxx = common.isShowItem('searchBasicInfo', setListMenu)
      this.menuItem.jygl = common.isShowItem('searchViewOverview', setListMenu)
      this.menuItem.jr = common.isShowItem('searchViewFinance', setListMenu)
      this.menuItem.order = common.isShowItem('searchViewOrder', setListMenu)
      this.menuItem.ps = common.isShowItem('searchViewShipping', setListMenu)
      this.menuItem.bg = common.isShowItem('searchCustomsView', setListMenu)
      this.menuItem.cc = common.isShowItem('searchWarehousingView', setListMenu)
      this.menuItem.js = common.isShowItem('searchViewSettlement', setListMenu)
      this.menuItem.myReport = common.isShowItem('myReport', setListMenu)
    }
    this.list = [
      {
        name: '基本信息',
        compontents: 'jbxx',
        isShow: this.menuItem.jbxx
      }, {
        name: '经营概览',
        compontents: 'jygl',
        isShow: this.menuItem.jygl
      }, {
        name: '金融',
        compontents: 'jr',
        isShow: this.menuItem.jr
      }, {
        name: '订单',
        compontents: 'order',
        isShow: this.menuItem.order
      },
      // , {
      //   name: '配送',
      //   compontents: 'ps',
      //   isShow: this.menuItem.ps
      // }
      {
        name: '物流',
        compontents: 'wl',
        isShow: true
        // isShow: this.menuItem.ps
      },
      {
        name: '报关',
        compontents: 'bg',
        isShow: this.menuItem.bg
      }, {
        name: '仓储',
        compontents: 'cc',
        isShow: this.menuItem.cc
      }, {
        name: '结算',
        compontents: 'js',
        isShow: this.menuItem.js
      }
    ]
    // 处理总列表没权限时的展示
    this.list.some(i => {
      if (i.isShow) {
        this.menuItem.hasList = true
        return true
      }
    })
    this.getRate()
  },

  mounted () {
    this.show = 0
    // this.filter.searchDate = new Date().getFullYear() + ''
    this.clearAll(1)
    let data = sessionStorage.getItem('user')
    if (data) {
      data = JSON.parse(data)
    }
    this.$store.dispatch('getDict', {})
    let width = 1920
    let height = 1080
    let scalex = document.body.clientWidth / width
    // let scaley = document.body.clientHeight / height
    this.transform = `scale(${scalex},${scalex})`
    this.left = `-${((1 - scalex) * width) / 2}px`
    this.top = `-${((1 - scalex) * height) / 2}px`
    window.onresize = (e) => {
      let scalex = document.body.clientWidth / width
      // let scaley = document.body.clientHeight / height
      this.transform = `scale(${scalex},${scalex})`
      this.left = `-${((1 - scalex) * width) / 2}px`
      this.top = `-${((1 - scalex) * height) / 2}px`
    }
  },

  methods: {
    setProductCollect (productCollect) {
      let str = ''
      if (productCollect && productCollect.length > 13) {
        str = productCollect.substring(0, 13) + '......'
      }
      return str
    },
    setTransaction (val) {
      return (val / 10000).toFixed(2)
    },
    ...mapMutations(['setModelInfo', 'setSearchTime']),
    clearAll (flag) {
      this.isSearch = false
      this.filter = {
        customerName: '',
        productCollect: '',
        searchDate: '',
        countryCollect: '全部站点',
        leimu: '全部商品目录',
        platformCollect: '全部平台'
      }
      this.page = {
        isLoadPage: true,
        current: 1,
        size: 10,
        total: 0
      }
      this.searchKeyword()
    },
    // 关闭弹框
    close () {
      this.checked = ''
      this.$router.back()
    },
    hidden () {
      this.show--
    },
    showTipes () {
      this.tipsShow = true
    },
    handleTableSelect (e) {
      // this.$router.push({ name: 'bigDataDetail', params: e })
      this.list.some(i => {
        if (i.isShow) {
          this.checked = i.compontents
          return true
        }
      })
      this.info = e
      this.show = 1
    },
    currentChange (e) {
      this.detailpage.current = e
      this.page.current = e
      this.getDetailList()
    },
    change (e) {
      if (this.page.isLoadPage) {
        this.page.current = e
        this.loadList()
      }
    },
    reportcurrentChange (e) {
      this.reportpage.current = e
      this.reporttableData = this.reporttableDatas.slice(((this.reportpage.current - 1) * this.reportpage.size), (this.reportpage.current) * this.reportpage.size - 1)
    },
    sizeChange (e) {
      this.detailpage.size = e
      this.detailpage.current = 1
      this.getDetailList()
    },
    changesize (e) {
      this.page.size = e
      if (this.page.isLoadPage) {
        this.setDafault(() => {
          this.page.size = e
          this.loadList()
        })
      }
    },
    reportsizeChange (e) {
      this.reportpage.current = 1
      this.reportpage.size = e
      this.reporttableData = this.reporttableDatas.slice(((this.reportpage.current - 1) * this.reportpage.size), (this.reportpage.current) * this.reportpage.size - 1)
    },
    getDetailList () {
      // document.getElementById('search').scrollTop = 0
      let url = 'listViewOrderDetails'
      if (this.detailType === 'bg') {
        url = 'listCustomsDetailByCustomsNo'
        const loadTips = Loading.service()
        this.$ajax({
          method: 'post',
          url: `${apiPath.bigData.search[url]}`,
          data: {
            'pageNum': this.page.current,
            'pageSize': this.page.size,
            'customsNo': this.detailInfo.customsNo === '全部' ? '' : this.detailInfo.customsNo,
            'searchDate': this.searchDate
          }
        }).then(res => {
          loadTips.close()
          res.data.map(item => { item.customsStatus = item.customsStatus })
          this.detailtableData = res.data
          this.detailpage.total = res.total
          this.show = 2
        })
      } else {
        const loadTips = Loading.service()
        let sendData = {
          // orderId: this.detailInfo.orderId || '',
          orderId: this.detailInfo.id,
          customerNo: this.info.customerNo,
          // orderId：111-0025016-9770669  customerNo：AABL 测试数据
          'pageNum': this.page.current,
          'pageSize': this.page.size
        }
        if (this.checked === 'order') {
          if (this.detailInfo.dataFlag === 0) {
            sendData['orderId'] = this.detailInfo.orderId
            delete sendData['id']
          }
        }
        this.$ajax({
          method: 'post',
          url: `${apiPath.bigData.search.order.getSalesOrderDetail}`,
          data: sendData
        }).then(res => {
          loadTips.close()
          this.detailtableData = res.data.records || []
          this.detailpage.total = res.data.total
          document.body.scrollTo = 0
          this.show = 2
        })
      }
    },
    detail (data) {
      // data.row.customsNo = '全部'
      this.detailInfo = data.row
      this.detailType = data.type
      // document.body.scrollTop = 0
      this.$refs.search.scrollTop = 0
      if (data.type === 'bg') {
        this.detailtableHeader = this.detailtableHeader2
        let sendData = {
          'pageNum': this.detailpage.current,
          'pageSize': this.detailpage.size,
          'customsNo': this.detailInfo.customsNo === '全部' ? '' : this.detailInfo.customsNo,
          'searchDate': this.searchDate,
          'searchParam': '',
          'sortParam': '',
          'yearTime': this.searchDate,
          'productCollect': this.detailInfo.productCollect
        }
        this.$ajax({
          method: 'post',
          url: `${apiPath.bigData.search.getCustomsDetailByCustomsNo}`,
          data: sendData
        }).then(res => {
          let data = res.data
          this.detailList = [
            {
              name: '报关单号',
              value: data.customsNo
            }, {
              name: '报关方式',
              value: data.customsType
            }, {
              name: '海关编码',
              value: data.customsCode
            }, {
              name: '目的国',
              value: data.country
            }, {
              name: '物流商',
              value: data.customerName
            }, {
              name: '发货人',
              value: data.shipper
            }, {
              name: '收货人',
              value: data.receiver
            }, {
              name: '数量',
              value: data.customsProductPiece
            }, {
              name: '重量',
              value: data.customsWeight
            }, {
              name: '申报价值',
              value: data.price
            }, {
              name: '状态',
              value: data.customsStatus
            }, {
              name: '报关时间',
              value: data.customsTime
            }
          ]
        })
      } else {
        const {row} = data
        this.detailList = [
          {
            name: '订单编号',
            value: row.orderId
          }, {
            name: '所属平台',
            value: row.platform
          }, {
            name: '店铺',
            value: row.accountName || row.shopName
          }, {
            name: '商品数量',
            value: row.salesNum
          }, {
            name: '承运人',
            value: row.orgName
          }, {
            name: '运单编号',
            value: row.customerNumber
          }, {
            name: '订单状态',
            value: this.setOrderStatus(row.orderStatus) || row.orderStatus
          }, {
            name: '订单日期',
            value: row.purchaseDate
          }
        ]
        this.detailtableHeader = this.detailtableHeader1
      }
      this.getDetailList()
    },
    choose (e) {
      e && (this.checked = e.compontents)
    },
    timeChange (e) {
      this.searchDate = e
      this.setSearchTime(e)
    },
    getsendReport () {
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.getRiskReportTemplates}`,
        data: {}
      }).then(res => {
        res.data.map(item => {
          item.scopeExecutionName = scopeExecutionJson[item.scopeExecution]
        })
        this.reporttableDatas = JSON.parse(JSON.stringify(res.data))
        this.reporttableData = JSON.parse(JSON.stringify(res.data)).slice(((this.reportpage.current - 1) * this.reportpage.size), (this.reportpage.current) * this.reportpage.size - 1)
        this.reportpage.total = res.data.length
        this.reportSendshow = true
      }).catch(e => {
      })
    },
    setOrderStatus (orderStatus) {
      return common.orderStatus(orderStatus)
    },
    getCurrentRow (e) {
      for (let i = 0; i < this.reporttableData.length; i++) {
        if (this.reporttableData[i].reportNo === e.reportNo) {
          this.radio = i
          this.multipleSelection = this.reporttableData[i]
        }
      }
      // this.radio = e['$index']
      // this.multipleSelection = e.row
    },
    sendReport () {
      if (!this.multipleSelection) {
        return common.warningInfoTip('选择数据报告模板')
      }
      let data = sessionStorage.getItem('user')
      if (data) {
        data = JSON.parse(data)
      }
      var getUId = common.getUserId()
      const loadTips = Loading.service()
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.createDefaultRiskReport}`,
        data: {
          'customerName': this.info.customerName || '',
          'customerNo': this.info.companyNo || 'AAAA',
          'dataDimension': this.multipleSelection.dataDimension || '',
          'id': this.multipleSelection.id || '',
          'isEnable': this.multipleSelection.isEnable,
          'reportName': this.multipleSelection.reportName || '',
          'reportNo': this.multipleSelection.reportNo || '',
          'scopeExecution': this.multipleSelection.scopeExecution,
          'termValidity': this.multipleSelection.termValidity || '',
          'uniqueId': this.multipleSelection.uniqueId || '',
          // 'updateTime': this.multipleSelection.updateTime,
          'userId': getUId
        }
      }).then(res => {
        loadTips.close()
        if (res && res.status === 0) {
          this.saveReport()
        }
      }).catch(e => {
        loadTips.close()
      })
    },
    saveReport () {
      const loadTips = Loading.service()
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.saveReport}`,
        data: {
          'customerName': this.info.customerName,
          'reportName': this.multipleSelection.reportName
        }
      }).then(res => {
        loadTips.close()
        if (res && res.status === 0) {
          common.successInfoTip('报告生成成功')
          this.reporttableData = []
          this.reportSendshow = false
        }
      }).catch(e => {
        loadTips.close()
      })
    },
    searchDateChange (e) {
      this.timeChange(e)
      this.searchKeyword()
    },
    // 搜索
    searchKeyword () {
      this.setDafault(() => {
        this.loadList()
      })
    },
    // 设置默认信息
    setDafault (cb) {
      this.page.isLoadPage = false
      this.page.current = 1
      this.page.size = 10
      cb && cb()
    },
    // 获取列表
    loadList () {
      const loadTips = Loading.service()
      let data = {
        pageNum: this.page.current,
        pageSize: this.page.size,
        // enterTime: this.filter.searchDate,
        productCollect: this.filter.productCollect,
        customerName: this.filter.customerName,
        countryCollect: this.filter.countryCollect === '全部站点' ? '' : this.filter.countryCollect,
        categoryName: this.filter.leimu === '全部商品目录' ? '' : this.filter.leimu,
        platformCollect: this.filter.platformCollect === '全部平台' ? '' : this.filter.platformCollect
      }
      if (this.filter.searchDate) {
        data.enterBeginTime = this.filter.searchDate[0]
        data.enterEndTime = this.filter.searchDate[1]
      }
      console.log('data', data)
      this.$ajax({
        method: 'post',
        url: `${apiPath.bigData.search.search}`,
        data
      }).then(res => {
        this.page.isLoadPage = true
        loadTips.close()
        if (res) {
          const dataInfo = res.data || {}
          this.tableData = dataInfo.records || []
          this.page.total = dataInfo.total
        }
      }).catch(e => {
        loadTips.close()
      })
    },
    setWidth (item) {
      let setW = 'auto'
      if (item === 'customerName') {
        setW = 180
      } else if (item === 'parkTime') {
        setW = 130
      }
      return setW
    },
    // 汇率换算表
    getRate () {
      const loadTips = Loading.service()
      let data = {
        pageNum: 1,
        pageSize: 10000
      }
      this.$ajax({
        method: 'post',
        url: apiPath.bigData.search.listEcSysConversionRate,
        data: data
      }).then(res => {
        loadTips.close()
        this.rateData.date = res.data.rateDate
        if (res.data && res.data.page.records) {
          let dataInfo = res.data.page
          this.rateData.base = 'CNY'
          this.rateData.list = dataInfo.records || []
        }
      }).catch(() => {
        loadTips.close()
      })
    },
    // 特殊处理企业名称
    checkCompanyName (name) {
      let rerult = name
      this.checkCompanyNameList.includes(name) && (rerult = `(SZ融资)${rerult}`)
      return rerult
    },
    // 新单跟踪搜索弹窗
    doSearchOrder () {
      this.$refs.searchOrderCompontentRef && this.$refs.searchOrderCompontentRef.init()
    }
  }
}
</script>

<style lang="scss" scoped>
  .el-year-table td.today .cell{
    color: #606266;
    font-weight: 500;
  }
  .search{
    width: 1920px;
    height: 1080px;
    position: absolute;
    top:0;
    left:0;
    // background: url('~@/assets/images/home/bg.png') no-repeat 0 0;
    .headPic img {
      width: 16px;
      height: 16px;
      border-radius: 50%;
      vertical-align: -5px;
      margin-right: 5px;
    }
    // transform:scale(0.7,0.7);
    .search-head{
      line-height: 40px;
      font-size: 20px;
      line-height: 40px;
      margin-left: 32px;
      margin-right: 32px;
      padding-top: 16px;
      display: flex;
      position: relative;
      align-items: center;
      justify-content: space-between;
      .close{
        width: 87px;
        height: 30px;
        cursor: pointer;
        align-items:center;
        display: flex;
        img{
          width: 24px;
          height: 24px;
          margin-right:10px;
        }
      }
      .buttons{
        display: flex;
        align-items: center;
        position: absolute;
        right: 12px;
        height: 36px;
        top: 64px;
        .time{
          margin-right: 16px;
        }
      }
    }
    .search-list{
      margin: 32px 32px;
      .mr-16px{
        margin-right: 16px;
        width: 250px;
      }
      .filter{
        .filter-top{
          padding:16px 32px;
          display: flex;
          align-items: center;
          margin-bottom:16px;
          width: 1400px;
          border:1px solid rgb(71,166,234);
          border-radius: 4px;
          .line{
            height: 32px;
            width: 2px;
            background: rgb(71,166,234);
            margin-right: 16px;
            margin-left: 24px;
          }
          .input{
            display: flex;
            width: 600px;
            align-items: center;
            .text{
              width: 100px;
              font-size:16px;
              // color:rgb(71,166,234);
            }
          }
        }
        .filter-list{
          display: flex;
          align-items: center;
        }
        .tips{
          margin-top:12px;
          margin-bottom:4px;
          .red{
            color:red;
          }
        }
      }
    }
    .content{
      .bg{
        background: url('/static/img/bg.png') no-repeat 0 0;
      }
      .pannels{
        height: 30px;
        line-height: 30px;
        display: flex;
        margin-top:16px;
        border-bottom:1px solid rgb(71,166,234);
        padding-left:40px;
        .pannel{
          width: 100px;
          border:1px solid rgb(71,166,234);
          border-bottom: none;
          cursor: pointer;
          border-top-left-radius: 6px;
          text-align: center;
          border-top-right-radius: 6px;
          margin-right: 16px;
          // line-height: 40px;
        }
        .active{
          background: rgb(71,166,234);
          color: #fff;
        }
      }
    }
    .detail-main{
      .detail-head{
        display: flex;
        border: 1px solid rgb(71,166,234);
        border-radius: 6px;
        padding: 24px 20px 0px 20px;
        margin:32px 40px 16px 40px;
        font-size: 18px;
        flex-wrap: wrap;
        .detail-head-item {
          display: flex;
          justify-content: space-around;
          text-align: center;
          width: 299px;
          margin-bottom:24px;
          .left{
            text-align: right;
          }
          .right{
            text-align: left;
          }
        }
      }
      .detail-search{
        display: flex;
        margin:24px 40px 12px 40px;
        .detail-search-item{
          display: flex;
          align-items: center;
          margin-right: 40px;
          .search-item-text{
            width: 120px;
            text-align: right;
            margin-right: 16px;
            font-size: 16px;
          }
        }
      }
      .detail-table{
        margin: 0 40px
      }
    }
    .myReport{
      position: relative;
      display: flex;
      align-items: center;
      margin-right: 10px;
      cursor: pointer;
      img{
        width: 20px;
        height: 20px;
        margin-right: 12px;
      }
      .report-list{
        position: absolute;
        z-index: 9;
        top:36px;
        left:-60px;
        width: 200px;
        padding:12px 16px;
        background: rgba(24,127,215,.8) !important;
        color:#fff;
        border:1px solid #fff;
        border-radius: 4px;
      }
      .report-close{
        position: absolute;
        z-index: 9;
        top:-15px;
        right:-15px;
        width: 30px;
        height: 30px;
        cursor: pointer;
      }
      .report-item{
        display: flex;
        align-items: center;
        // height: 48px;
        padding: 8px 0;
        border-bottom: 1px solid #fff;
        img{
          width: 24px;
          height:24px;
          margin-right:16px;
        }
      }
    }
  }
</style>
<style lang="scss">
  .filter-top{
    .el-button{
      line-height:32px !important;
    }
  }
  .time{
    .el-range-input {
      background: transparent !important;
    }
    .el-input{
      width: 250px;
    }
    .el-input__inner{
      background: rgba(24,127,215,0.2);
      border: 1px solid #2d6bab;
      height: 36px;
      line-height: 36px;
      color: #fff;
    }
  }
  .search{
    .ux-panel{
      position: relative;
      z-index: 1;
      padding-top: 70px;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      border: 1px solid #22bdfe;
      background: rgba(17, 47, 72, 0.9);
      .title{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 70px;
        line-height: 70px;
        text-align: center;
        font-size: 24px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        background: linear-gradient(180deg, #eeeeee 0%, #4dc5ff 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .title::after {
        position: absolute;
        content: "";
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100% - 30px * 2);
        height: 0;
        border: 1px solid;
        border-image: linear-gradient(63deg, rgba(71, 241, 255, 0), #38c2ff, rgba(34, 222, 254, 0)) 1 1;
      }
      .tabs{
        padding: 0 30px;
        box-sizing: border-box;
        .tabs-header{
          // margin-bottom:20px;
          text-align: center;
        }
        .tabs-header {
          .ux-dark-el-radio {
            .is-active,
            .is-focus {
              span {
                color: #ffffff;
                box-shadow: -1px 0 0 0 #1c8be2;
                border-color: #1c8be2;
                background-color: #1c8be2;
              }
            }
            span {
              padding: 9px 12px;
              font-size: 16px;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #2bb0f0;
              border-color: #2d6bab;
              background: rgba(24, 127, 215, 0.2);
            }
          }
          .el-radio-button__inner{
            margin: 0 4px;
            padding: 10px 12px;
            font-size: 18px;
            border-radius: 0px 0px 4px 4px;
            color: #2bb0f0;
            border: 1px solid #2d6bab;
            background: rgba(24, 127, 215, 0.2);
          }
          .el-radio-group{
            font-size: 0
          }
        }
        .tabs-pane {
          .el-tabs {
            .el-tabs__header {
              display: none;
            }
          }
          .ux-table-wrap {
          }
        }
        table {
          .cell {
            padding: 12px 10px;
          }
          .el-table__cell{
             border-right: 1px solid #2d6bab;
             border-bottom: 1px solid #2d6bab;
          }
          th .cell {
            text-align: center;
            font-size: 18px !important;
          }
        }
      }
    }
    .ux-filter-records {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      // padding: 20px 30px 0;
      box-sizing: border-box;
      .filter {
        display: flex;
        flex-wrap: wrap;
        .search {
          color: #ffffff;
          background: #1c8be2;
        }
      }
      .content-list {
        margin-top: 10px;
        flex: none;
        // min-height: 517px;
        .blue{
          color: #1c8be2;
          cursor: pointer;
        }
        .table {
          height: 100%;
          .el-table__header-wrapper {
            tr {
              th {
                height: 50px;
              }
            }
          }
          .el-table__body-wrapper {
            tr {
              td {
                height: 50px;
              }
            }
          }
          .el-loading-mask {
            // background: rgba(0, 0, 0, 0.8);
            .el-loading-spinner {
              font-size: 24px;
            }
          }
          .text {
            font-size: 16px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }
        .ux-dark-el-table {
          display: flex;
          flex-direction: column;
          border: 1px solid #2d6bab;
          background-color: transparent;
          table {
            tr {
              background: rgba(24, 127, 215, 0.1) !important;
              &:last-child {
                td {
                  border-bottom: none;
                }
              }
              th {
                padding: 0;
                border-color: #2d6bab !important;
                background: rgba(24, 127, 215, 0.3) !important;
                &:last-child {
                  border-right: none;
                }
                .cell {
                  font-size: 16px;
                  font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                  font-weight: 500;
                  color:#fff;
                  // background: linear-gradient(180deg, #eeeeee 0%, #4dc5ff 100%);
                  // background-clip: text;
                  // -webkit-text-fill-color: transparent;
                }
              }
              td {
                padding: 0;
                font-size: 14px;
                font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                font-weight: 500;
                color: #ffffff;
                border-color: #2d6bab;
                &:last-child {
                  border-right: none;
                }
              }
            }
          }
          td.el-table__cell{
            border-bottom: 1px solid #2d6bab;
          }
          &::before {
            display: none;
          }
          // tbody row hover
          &.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
            background: rgba(24, 127, 215, 0.2);
          }
          // 多级表头
          &.el-table--group::after,
          // 带边框表格
          &.el-table--border::after {
            content: unset;
          }
          .el-table__body-wrapper {
            flex: 1 1;
            table {
              height: 100%;
            }
          }
          .el-table__footer-wrapper tbody td.el-table__cell {
            font-size: 16px;
            background-color: transparent;
          }
        }
      }
      .pages {
        margin-top: 20px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        height: 28px;
        font-size: 16px;
        font-weight: 400;
        color: #fff;
      }
    }
    }
    .el-input-dark {
      .el-input__inner{
        height: 36px;
        line-height: 36px;
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #ffffff;
        border: 1px solid #2d6bab;
        background: rgba(24, 127, 215, 0.2);
        padding: 0 15px !important;
      }
      .search {
          color: #ffffff;
          background: #1c8be2;
      }
      .el-input__wrapper{
        padding: 0 !important;
        margin-bottom:0 !important;
        box-shadow: none !important;
      }
      .el-input--suffix{
        margin-bottom:0 !important;
      }
      .el-input__suffix {
        right: 5px;
        transition: all .3s;
        position: absolute;
        top: 0;
        height: 100%;
        color: #C0C4CC;
        text-align: center;
      }
      .select-trigger{
        margin-bottom:0 !important;
      }
    }
    .el-btn-dark{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 80px;
      height: 36px;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #2bb0f0;
      border: 1px solid #2d6bab;
      background: transparent;
      &:focus,
      &:hover {
        color: #2bb0f0;
        border-color: #2d6bab;
        background: transparent;
      }
    }
    .ux-dark-el-pagination {
      padding-right: 0;
      .btn-prev,
      .el-pager li,
      .el-pager li:last-child,
      .el-pager li.active,
      .btn-next {
        min-width: 28px !important;
        min-height: 28px !important;
        line-height: 26px !important;
        font-size: 16px !important;
        color: #ffffff !important;
        border: 1px solid #2d95ea;
        background-color: transparent !important;
      }
      .el-input__inner{
        background: transparent !important;
        // width: 80px !important;
        color: #fff !important;
      }
      .el-pager li.active {
        background: #1c8be2 !important;
      }
      .btn-next {
        margin-right: 0 !important;
      }
    }
</style>
<style lang='scss'>
  .reportDialog{
    width: 1410px;
    height: 775px;
    margin-top: 0;
    margin-bottom: 0;
    top: 0;
    left: 50%;
    transform: translateX(-40%);
    z-index: 2018;
    position: absolute;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    .el-dialog__header{
      display: none;
      padding:0;
    }
    .el-dialog__body{
      position: relative;
      padding: 0;
      height: 100%;
    }
    .mask{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
      border-radius: 0px;
      background: rgba(0, 0, 0, 0.5);
    }
    .ux-panel{
      position: relative;
      z-index: 1;
      padding-top: 70px;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      border: 1px solid #22bdfe;
      background: rgba(17, 47, 72, 0.9);
      .head-list{
        display: flex;
        margin-top: 32px;
        justify-content: space-between;
        padding: 0 150px;
        color:#fff;
        font-size:24px;
      }
      .title{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 70px;
        line-height: 70px;
        text-align: center;
        font-size: 24px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        background: linear-gradient(180deg, #eeeeee 0%, #4dc5ff 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .title::after {
        position: absolute;
        content: "";
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100% - 30px * 2);
        height: 0;
        border: 1px solid;
        border-image: linear-gradient(63deg, rgba(71, 241, 255, 0), #38c2ff, rgba(34, 222, 254, 0)) 1 1;
      }
      .tabs{
        padding: 0 30px;
        box-sizing: border-box;
        .tabs-header{
          // margin-bottom:20px;
          text-align: center;
        }
        .tabs-header {
          .ux-dark-el-radio {
            .is-active,
            .is-focus {
              span {
                color: #ffffff;
                box-shadow: -1px 0 0 0 #1c8be2;
                border-color: #1c8be2;
                background-color: #1c8be2;
              }
            }
            span {
              padding: 9px 12px;
              font-size: 16px;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #2bb0f0;
              border-color: #2d6bab;
              background: rgba(24, 127, 215, 0.2);
            }
          }
          .el-radio-button__inner{
            margin: 0 4px;
            padding: 10px 12px;
            font-size: 18px;
            border-radius: 0px 0px 4px 4px;
            color: #2bb0f0;
            border: 1px solid #2d6bab;
            background: rgba(24, 127, 215, 0.2);
          }
          .el-radio-group{
            font-size: 0
          }
        }
        .tabs-pane {
          .el-tabs {
            .el-tabs__header {
              display: none;
            }
          }
          .ux-table-wrap {
          }
        }
        table {
          .cell {
            padding: 12px 10px;
          }
          .el-table__cell{
             border-right: 1px solid #2d6bab;
             border-bottom: 1px solid #2d6bab;
          }
          th .cell {
            text-align: center;
            font-size: 18px !important;
          }
        }
      }
      .close{
        position: absolute;
        right: 20px;
        top: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: content-box;
        padding: 5px;
        width: 24px;
        height: 24px;
        cursor: pointer;
        img{
          width: 30px;
          height: 30px;
        }
      }
    }
    .ux-filter-records {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 20px 30px 0;
    box-sizing: border-box;
    .filter {
      display: flex;
      flex-wrap: wrap;
      // div {
      //   margin-right: 18px;
      //   margin-bottom: 10px;
      // }
      .search {
        color: #ffffff;
        background: #1c8be2;
      }
    }
    .content-list {
      margin-top: 10px;
      flex: none;
      min-height: 577px;
      .table {
        height: 100%;
        .el-table__header-wrapper {
          tr {
            th {
              height: 50px;
            }
          }
        }
        .el-table__body-wrapper {
          tr {
            td {
              height: 50px;
            }
          }
        }
        .el-loading-mask {
          /* background: rgba(0, 0, 0, 0.8); */
          .el-loading-spinner {
            font-size: 24px;
          }
        }
        .text {
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
      .ux-dark-el-table {
        display: flex;
        flex-direction: column;
        border: 1px solid #2d6bab;
        background-color: transparent;
        table {
          tr {
            background: rgba(24, 127, 215, 0.1) !important;
            &:last-child {
              td {
                border-bottom: none;
              }
            }
            th {
              padding: 0;
              border-color: #2d6bab !important;
              background: rgba(24, 127, 215, 0.3) !important;
              &:last-child {
                border-right: none;
              }
              .cell {
                font-size: 16px;
                font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                font-weight: 500;
                color:#fff;
                // background: linear-gradient(180deg, #eeeeee 0%, #4dc5ff 100%);
                // background-clip: text;
                // -webkit-text-fill-color: transparent;
              }
            }
            td {
              padding: 0;
              font-size: 14px;
              font-family: SourceHanSansCN-Medium, SourceHanSansCN;
              font-weight: 500;
              color: #ffffff;
              border-color: #2d6bab;
              &:last-child {
                border-right: none;
              }
            }
          }
        }
        td.el-table__cell{
          border-bottom: 1px solid #2d6bab;
        }
        &::before {
          display: none;
        }
        // tbody row hover
        &.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
          background: rgba(24, 127, 215, 0.2);
        }
        // 多级表头
        &.el-table--group::after,
        // 带边框表格
        &.el-table--border::after {
          content: unset;
        }
        .el-table__body-wrapper {
          flex: 1 1;
          table {
            height: 100%;
          }
        }
        .el-table__footer-wrapper tbody td.el-table__cell {
          font-size: 16px;
          background-color: transparent;
        }
      }
    }
    .pages {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 28px;
      font-size: 16px;
      font-weight: 400;
      color: #fff;
      border-bottom: 1px solid #2d6bab;
      padding-bottom: 20px;
    }
  }
  }
  .el-input-dark {
    .el-input__inner{
      height: 36px;
      line-height: 36px;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #ffffff;
      border: 1px solid #2d6bab;
      background: rgba(24, 127, 215, 0.2);
      padding: 0 15px !important;
    }
    .search {
        color: #ffffff;
        background: #1c8be2;
    }
    .el-input__wrapper{
      padding: 0 !important;
      margin-bottom:0 !important;
      box-shadow: none !important;
    }
    .el-input--suffix{
      margin-bottom:0 !important;
    }
    .el-input__suffix {
      right: 5px;
      transition: all .3s;
      position: absolute;
      top: 0;
      height: 100%;
      color: #C0C4CC;
      text-align: center;
    }
    .select-trigger{
      margin-bottom:0 !important;
    }
  }
  .el-btn-dark{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 36px;
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #2bb0f0;
    border: 1px solid #2d6bab;
    background: transparent;
    &:focus,
    &:hover {
      color: #2bb0f0;
      border-color: #2d6bab;
      background: transparent;
    }
  }
  .el-table .el-table__cell{
    color: #000
  }
  .search{
    .time{
      // display: flex;
      //   position: absolute;
      //   right: 90px;
      //   top: 62px;
      .el-input__inner{
        background: transparent;
        color: #fff;
      }
       .el-tooltip__popper{
    width: 100px !important;
    text-align: center;
  }
  .el-year-table td.today .cell{
    color: #606266;
    font-weight: 500;
  }
    }
  }
</style>
<style lang='scss'>
  .el-dialog{
    min-width: 50%;
    // margin: 0 !important;
  }
  .commonDialog1{
    // width: 1410px;
    .report-buttons{
      display: flex;
      justify-content: space-around;
      padding:12px 160px;
      margin-bottom: 16px;
    }
    width: 90% !important;
    // top: 5%;
    // min-height: 770px !important;
    margin-bottom: 0 !important;
    margin-top: 0 !important;
    margin-left: 0 !important;
    margin-left: 0 !important;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 2018;
    position: absolute;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
    .el-dialog__header{
      display: none;
      padding:0;
    }
    .el-dialog__body{
      position: relative;
      padding: 0;
      height: 100%;
    }
    .mask{
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
      border-radius: 0px;
      background: rgba(0, 0, 0, 0.5);
    }
    .ux-panel{
      position: relative;
      z-index: 1;
      padding-top: 70px;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      border: 1px solid #22bdfe;
      background: rgba(17, 47, 72, 0.9);
      .head-list{
        display: flex;
        margin-top: 32px;
        justify-content: space-between;
        padding: 0 150px;
        color:#fff;
        font-size:24px;
      }
      .title{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 70px;
        line-height: 70px;
        text-align: center;
        font-size: 24px;
        font-family: SourceHanSansCN-Medium, SourceHanSansCN;
        font-weight: 500;
        background: linear-gradient(180deg, #eeeeee 0%, #4dc5ff 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      .title::after {
        position: absolute;
        content: "";
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: calc(100% - 30px * 2);
        height: 0;
        border: 1px solid;
        border-image: linear-gradient(63deg, rgba(71, 241, 255, 0), #38c2ff, rgba(34, 222, 254, 0)) 1 1;
      }
      .index{
        position: relative;
        img {
          position: absolute;
          top: 0px;
          left:56px;
          width: 20px;
          height: 20px;
        }
      }
      .tabs{
        padding: 0 30px;
        box-sizing: border-box;
        .tabs-header{
          // margin-bottom:20px;
          text-align: center;
        }
        .tabs-header {
          .ux-dark-el-radio {
            .is-active,
            .is-focus {
              span {
                color: #ffffff;
                box-shadow: -1px 0 0 0 #1c8be2;
                border-color: #1c8be2;
                background-color: #1c8be2;
              }
            }
            span {
              padding: 9px 12px;
              font-size: 16px;
              font-family: SourceHanSansCN-Regular, SourceHanSansCN;
              font-weight: 400;
              color: #2bb0f0;
              border-color: #2d6bab;
              background: rgba(24, 127, 215, 0.2);
            }
          }
          .el-radio-button__inner{
            margin: 0 4px;
            padding: 10px 12px;
            font-size: 18px;
            border-radius: 0px 0px 4px 4px;
            color: #2bb0f0;
            border: 1px solid #2d6bab;
            background: rgba(24, 127, 215, 0.2);
          }
          .el-radio-group{
            font-size: 0
          }
        }
        .tabs-pane {
          .el-tabs {
            .el-tabs__header {
              display: none;
            }
          }
          .ux-table-wrap {
          }
        }
        table {
          .cell {
            padding: 12px 10px;
          }
          .el-table__cell{
             border-right: 1px solid #2d6bab;
             border-bottom: 1px solid #2d6bab;
          }
          th .cell {
            text-align: center;
            font-size: 18px !important;
          }
        }
      }
      .close{
        position: absolute;
        right: 20px;
        top: 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: content-box;
        padding: 5px;
        width: 24px;
        height: 24px;
        cursor: pointer;
        img{
          width: 30px;
          height: 30px;
        }
      }
    }
    .ux-filter-records {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    padding: 20px 30px 0;
    box-sizing: border-box;
    .filter {
      display: flex;
      flex-wrap: wrap;
      // div {
      //   margin-right: 18px;
      //   margin-bottom: 10px;
      // }
      .search {
        color: #ffffff;
        background: #1c8be2;
      }
    }
    .content-list {
      margin-top: 10px;
      flex: none;
      // height: 550px;
      .table {
        height: 100%;
        .el-table__header-wrapper {
          tr {
            th {
              height: 50px;
            }
          }
        }
        .el-table__body-wrapper {
          tr {
            td {
              height: 50px;
            }
          }
        }
        .el-loading-mask {
          /* background: rgba(0, 0, 0, 0.8); */
          .el-loading-spinner {
            font-size: 24px;
          }
        }
        .text {
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
      }
      .ux-dark-el-table {
        display: flex;
        flex-direction: column;
        border: 1px solid #2d6bab;
        background-color: transparent;
        table {
          tr {
            background: rgba(24, 127, 215, 0.1) !important;
            &:last-child {
              td {
                border-bottom: none;
              }
            }
            th {
              padding: 0;
              border-color: #2d6bab !important;
              background: rgba(24, 127, 215, 0.3) !important;
              &:last-child {
                border-right: none;
              }
              .cell {
                font-size: 16px;
                font-family: SourceHanSansCN-Medium, SourceHanSansCN;
                font-weight: 500;
                color:#fff;
                // background: linear-gradient(180deg, #eeeeee 0%, #4dc5ff 100%);
                // background-clip: text;
                // -webkit-text-fill-color: transparent;
              }
            }
            td {
              padding: 0;
              font-size: 14px;
              font-family: SourceHanSansCN-Medium, SourceHanSansCN;
              font-weight: 500;
              color: #ffffff;
              border-color: #2d6bab;
              &:last-child {
                border-right: none;
              }
            }
          }
        }
        td.el-table__cell{
          border-bottom: 1px solid #2d6bab;
        }
        &::before {
          display: none;
        }
        // tbody row hover
        &.el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
          background: rgba(24, 127, 215, 0.2);
        }
        // 多级表头
        &.el-table--group::after,
        // 带边框表格
        &.el-table--border::after {
          content: unset;
        }
        .el-table__body-wrapper {
          flex: 1 1;
          table {
            height: 100%;
          }
        }
        .el-table__footer-wrapper tbody td.el-table__cell {
          font-size: 16px;
          background-color: transparent;
        }
      }
    }
    .pages {
      margin-top: 20px;
      margin-bottom: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 28px;
      font-size: 16px;
      font-weight: 400;
      color: #fff;
    }
  }
  }
  .el-input-dark {
    .el-input__inner{
      height: 36px;
      line-height: 36px;
      font-size: 16px;
      font-family: SourceHanSansCN-Regular, SourceHanSansCN;
      font-weight: 400;
      color: #ffffff;
      border: 1px solid #2d6bab;
      background: rgba(24, 127, 215, 0.2);
      padding: 0 15px !important;
    }
    .search {
        color: #ffffff;
        background: #1c8be2;
    }
    .el-input__wrapper{
      padding: 0 !important;
      margin-bottom:0 !important;
      box-shadow: none !important;
    }
    .el-input--suffix{
      margin-bottom:0 !important;
    }
    .el-input__suffix {
      right: 5px;
      transition: all .3s;
      position: absolute;
      top: 0;
      height: 100%;
      color: #C0C4CC;
      text-align: center;
    }
    .select-trigger{
      margin-bottom:0 !important;
    }
  }
  .el-btn-dark{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px;
    height: 36px;
    font-size: 16px;
    font-family: SourceHanSansCN-Regular, SourceHanSansCN;
    font-weight: 400;
    color: #2bb0f0;
    border: 1px solid #2d6bab;
    background: transparent;
    &:focus,
    &:hover {
      color: #2bb0f0;
      border-color: #2d6bab;
      background: transparent;
    }
  }
  .ux-dark-el-pagination {
    padding-right: 0;
    .btn-prev,
    .el-pager li,
    .el-pager li:last-child,
    .el-pager li.active,
    .btn-next {
      min-width: 28px !important;
      min-height: 28px !important;
      line-height: 26px !important;
      font-size: 16px !important;
      color: #ffffff !important;
      border: 1px solid #2d95ea;
      background-color: transparent !important;
    }
    .el-pager li.active {
      background: #1c8be2 !important;
    }
    .btn-next {
      margin-right: 0 !important;
    }
  }
  .rate_box {
    color: #FF8D14;
    .icon {
      font-size: 24px;
      vertical-align: -5px;
      margin-left: 5px;
    }
  }
  .rate_list_box {
    .title {
      font-size: 16px;
      margin-bottom: 10px;
      em {
        font-weight: normal;
        font-size: 12px;
      }
    }
    .base {
      margin-bottom: 10px;
    }
    .dec {
      margin-bottom: 10px;
      color: #888;
      width: 300px;
    }
    .tab {
      width: 400px;
    }
  }
  .el-year-table td.today .cell{
    color: #606266;
    font-weight: 500;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/bigData/search/index.vue